import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SalePriceSchedule } from '../models/sale-price-schedule';
import { SalePriceScheduleType } from '../models/sale-price-schedule-type';


@Injectable()
export class SalePriceScheduleService {
  constructor() { }

  getAllSalePriceSchedule(): Observable<SalePriceSchedule[]> {
    return of();
  }

  getAllScheduleTypes(): Observable<SalePriceScheduleType[]> {
    return of();
  }
}
